// coverImage and logo assets for the report cover background
const coverImage = "/reportImages/cover.png";
const coverLogo = "/reportImages/cover-logo.png";
const layerImage = "/reportImages/layer.png";

// Utility to format the publication date into "Monday, 5th May 2025" format
const getFormattedDate = (publishDate) => {
  if (!publishDate) {
    return "Loading...";
  }

  const date = new Date(publishDate);
  const weekday = date?.toLocaleDateString("en-US", {
    weekday: "long",
  });
  const month = date?.toLocaleDateString("en-US", {
    month: "long",
  });

  const year = date?.getFullYear();
  const day = date?.getDate();

  // Get correct suffix for day
  const getDaySuffix = (day) => {
    // 11 12 and 13 is an exception for 'th'
    if (day % 10 === 1 && day !== 11) return "st";
    if (day % 10 === 2 && day !== 12) return "nd";
    if (day % 10 === 3 && day !== 13) return "rd";
    return "th";
  };

  return (
    <>
      {weekday}, {day}
      {getDaySuffix(day)} {month}, {year}
    </>
  );
};

// CoverPage component renders the report's title page with branding and publish date
const CoverPage = ({ date }) => (
  <div className="cover-page">
    <img src={coverImage} alt="Cover" className="cover-bg" />
    <img src={coverLogo} alt="Logo" className="cover-logo" />
    <img src={layerImage} alt="Layer" className="cover-layer" />

    <div className="cover-bottom-layer">
      <h1 className="cover-title">Weekly Water &amp; Weather Report</h1>
      <h6 className="cover-date">{getFormattedDate(date)}</h6>
    </div>
  </div>
);

export default CoverPage;
